import React from 'react';
export const FibraIcon = () => (React.createElement("svg", { version: "1.1", id: "Livello_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 84 84", xmlSpace: "preserve", width: "84", height: "84" },
    React.createElement("style", { type: "text/css" }, `
        .st0{fill:#E30613;}
        .st1{fill:#EE7203;}
        .st2{fill:#13A538;}
        .st3{fill:#FFFFFF;}
        .st4{font-family:'Roboto-Black';}
        .st5{font-size:46px;}
        .st6{font-family:'Roboto-Medium';}
        .st7{font-size:8px;}
      `),
    React.createElement("circle", { className: "st2", cx: "42", cy: "42", r: "41.81" }),
    React.createElement("text", { transform: "matrix(1 0 0 1 29.1638 49.7885)", className: "st3 st4 st5" }, "F"),
    React.createElement("text", { transform: "matrix(1 0 0 1 32.902 61.2838)", className: "st3 st6 st7" }, "Fibra")));
export const MistoRadioIcon = () => (React.createElement("svg", { version: "1.1", id: "Livello_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "84px", height: "84px", viewBox: "0 0 84 84", xmlSpace: "preserve" },
    React.createElement("style", { type: "text/css" }, `
        .st0{fill:#FFFFFF;} 
        .st1{fill:#FFCC00;} 
        .st2{fill:#13A538;} 
        .st3{fill:#FFFFFF;}
        .st4{font-family:'Roboto-Black';}
        .st5{font-size:46px;}
        .st6{font-family:'Roboto-Medium';}
        .st7{font-size:8px;} 
      `),
    React.createElement("circle", { className: "st1", cx: "42", cy: "42", r: "41.87" }),
    React.createElement("text", { transform: "matrix(1 0 0 1 14.4966 49.813)", className: "st3 st4 st5" }, "FR"),
    React.createElement("text", { transform: "matrix(1 0 0 1 31.7696 61.1685)", className: "st3 st6 st7" }, "Mista"),
    React.createElement("text", { transform: "matrix(1 0 0 1 22.8318 68.4307)", className: "st3 st6 st7" }, "Fibra-Radio")));
export const RameIcon = () => (React.createElement("svg", { version: "1.1", id: "Livello_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "84px", height: "84px", viewBox: "0 0 84 84", xmlSpace: "preserve" },
    React.createElement("style", { type: "text/css" }, `
        .st0{fill:#E30613;} 
        .st1{fill:#EE7203;} 
        .st2{fill:#13A538;} 
        .st3{fill:#FFFFFF;}
        .st4{font-family:'Roboto-Black';}
        .st5{font-size:46px;}
        .st6{font-family:'Roboto-Medium';}
        .st7{font-size:8px;} 
      `),
    React.createElement("circle", { className: "st1", cx: "42", cy: "42", r: "41.87" }),
    React.createElement("text", { transform: "matrix(1 0 0 1 14.4966 49.813)", className: "st3 st4 st5" }, "FR"),
    React.createElement("text", { transform: "matrix(1 0 0 1 31.7696 61.1685)", className: "st3 st6 st7" }, "Misto"),
    React.createElement("text", { transform: "matrix(1 0 0 1 20.8318 68.4307)", className: "st3 st6 st7" }, "Fibra-Rame")));
export const RadioIcon = () => (React.createElement("svg", { version: "1.1", id: "Livello_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "84px", height: "84px", viewBox: "0 0 84 84", xmlSpace: "preserve" },
    React.createElement("style", { type: "text/css" }, `
          .st0{fill:#E30613;}
          .st1{fill:#EE7203;}
          .st2{fill:#13A538;}
          .st3{fill:#FFFFFF;}
          .st4{font-family:'Roboto-Black';}
          .st5{font-size:46px;}
          .st6{font-family:'Roboto-Medium';}
          .st7{font-size:8px;}
          `),
    React.createElement("circle", { className: "st0", cx: "42", cy: "42", r: "42" }),
    React.createElement("circle", { className: "st1", cx: "42", cy: "149", r: "41.87" }),
    React.createElement("circle", { className: "st2", cx: "149", cy: "42", r: "41.81" }),
    React.createElement("text", { transform: "matrix(1 0 0 1 27.333 49.7885)", className: "st3 st4 st5" }, "R"),
    React.createElement("text", { transform: "matrix(1 0 0 1 31.7108 62.3814)", className: "st3 st6 st7" }, "Radio"),
    React.createElement("text", { transform: "matrix(1 0 0 1 136.1638 49.7885)", className: "st3 st4 st5" }, "F"),
    React.createElement("text", { transform: "matrix(1 0 0 1 139.902 61.2838)", className: "st3 st6 st7" }, "Fibra"),
    React.createElement("text", { transform: "matrix(1 0 0 1 14.4966 156.813)", className: "st3 st4 st5" }, "FR"),
    React.createElement("text", { transform: "matrix(1 0 0 1 31.7696 168.1685)", className: "st3 st6 st7" }, "Misto"),
    React.createElement("text", { transform: "matrix(1 0 0 1 20.8318 175.4307)", className: "st3 st6 st7" }, "Fibra-Rame")));
